import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import {ToasterService} from '../../globalServices/toaster.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
      private router: Router,
      // private authService: AuthService,
      private toastr: ToasterService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            // Gérer les erreurs d'auth
            //   this.toastr.error("Informations introuvables", "Opération échouée");

              console.error('Unauthorized');
              console.log('Unauthorized',error);

              // Rediriger vers la page de connexion
            // this.router.navigate(['/error-401']);
          } else if (error.status === 500) {
            // Gérer les erreurs serveur
            console.error('Internal Server Error');
                    // this.toastr.error("Une erreur s'est produite lors de l' operation. Veuillez réessayer.", "Opération échouée");

              //  this.authService.signOut();
            // Rediriger vers la page d'erreur
            // this.router.navigate(['/error-500']);
          }
          else if (error.status === 403) {
            // Gérer les erreurs serveur
            console.error('profil non vérifier');
              // this.router.navigate(['/auth/login']);

              // Rediriger vers la page d'erreur
            //   this.toastr.error("profil non vérifier", "Opération échouée");

              // this.router.navigate(['/error-403'],{ queryParams: {email: this.authService.loggedUser.email}});
          }
          else if (error.status === 404) {

              // this.router.navigate(['/auth/login']);
              // this.toastr.error("Ces information n'existent pas", "Opération échouée");
              // this.router.navigate(['/auth/login']);


          }else if (error.status === 422) {

              // this.router.navigate(['/auth/login']);
              // this.toastr.error("Informations incorrectes", "Opération échouée");

          } else {
            // Gérer d'autres erreurs
             // this.authService.signOut();
             //  this.toastr.error("Une erreur inattendue s'est produite. Veuillez réessayer plus tard.", "Opération échouée");

              // this.router.navigate(['/error-500']);
              // this.router.navigate(['/auth/login']);


              console.error('An error occurred:', error);
          }
          return throwError(error);
        })
    );
  }
}
